class metaobjectSwatchesForm extends HTMLElement {

  constructor () {
    super()
    this.init()
  }

  init () {
    this.addListeners()
  }

  addListeners () {
    this.lineItemContainer?.addEventListener('click', this.handleLineItemClick.bind(this))
    this.submitBtn?.addEventListener('click', this.addToCart.bind(this))

    window.addEventListener('on:bulkForm:updated', this.updateVisibility.bind(this))
  }

  handleLineItemClick (event) {
    if (!event.target.closest('[data-metaobject-form-line-item-remove]')) return

    event.preventDefault()
    event.stopPropagation()

    event.target.closest('.metaobject-form__line-item').remove()
    this.updateVisibility()
  }

  updateVisibility () {
    if (this.lineItems?.length > 0) {
      this.classList.remove('hidden')
      return
    }

    this.classList.add('hidden')
  }

  async addToCart () {
    const submitBtn = this.submitBtn
    submitBtn.disabled = true
    submitBtn.classList.add('is-loading')

    const formData = this.formData

    const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el)
    const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

    formData.sections_url = window.location.pathname
    formData.sections = sectionIds.join(',')

    const fetchRequestOpts = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData),
    }

    try {
      const response = await fetch(theme.routes.cartAdd, fetchRequestOpts)
      const data = await response.json()
      let error = typeof data.description === 'string' ? data.description : data.message
      if (data.errors && typeof data.errors === 'object') {
        error = Object.entries(data.errors).map((item) => item[1].join(', '))
      }
      if (data.status) this.setErrorMsgState(error)
      if (!response.ok) throw new Error(response.status)

      
      sectionsToUpdate.forEach((el) => {
        el.updateFromCartChange(data.sections[el.dataset.sectionId])
      })

      if (theme.settings.afterAddToCart === 'notification') {
        const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true)
        notification.dataset.productTitle = data.product_title
        let notificationContainer = document.querySelector('.pageheader--sticky')
        if (!notificationContainer) {
          notificationContainer = document.querySelector('body')
        }
        notificationContainer.appendChild(notification)
      } else if (theme.settings.afterAddToCart === 'drawer') {
        document.querySelector('.js-cart-drawer').open()
      }

      this.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: {
          variantId: data.variant_id
        }
      }))

      // Re-enable 'Add to Cart' button.
      this.submitBtn.classList.add('is-success')
      this.submitBtn.removeAttribute('aria-disabled')
      setTimeout(() => {
        this.submitBtn.classList.remove('is-loading')
        this.submitBtn.classList.remove('is-success')
      }, 2000)
    } catch (error) {
      console.log(error)
      this.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: this.errorMsg.textContent
        }
      }))

      // Re-enable 'Add to Cart' button.
      this.submitBtn.classList.remove('is-loading')
      this.submitBtn.classList.remove('is-success')
      this.submitBtn.removeAttribute('aria-disabled')

    }
  }

  /**
   * Shows/hides an error message.
   * @param {string} [error=false] - Error to show a message for.
   */
  setErrorMsgState(error = false) {
    this.errorMsg = this.errorMsg || this.querySelector('.js-form-error')
    if (!this.errorMsg) return

    this.errorMsg.hidden = !error
    if (error) {
      this.errorMsg.innerHTML = ''
      const errorArray = Array.isArray(error) ? error : [error]
      errorArray.forEach((err, index) => {
        if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>')
        this.errorMsg.insertAdjacentText('beforeend', err)
      })
    }
  }



  get lineItemContainer () {
    return this.querySelector('[data-metaobject-form-line-items]')
  }

  get lineItems () {
    return this.querySelectorAll('.metaobject-form__line-item')
  }

  get submitBtn () {
    return this.querySelector('[data-metaobject-form-submit]')
  }

  get formData () {
    const lineItems = this.lineItems

    if (!lineItems?.length > 0) return

    const formData = {}
    const items = []

    this.lineItems.forEach(lineItem => {
      const id = lineItem.dataset.variantId
      const quantity = lineItem.querySelector('[data-metaobject-form-quantity]')?.value

      items.push({ id, quantity })
    })

    formData.items = items

    return formData
  }
}

if (!customElements.get('metaobject-swatches-form')) {
  customElements.define('metaobject-swatches-form', metaobjectSwatchesForm)
}
